module.exports = __webpack_public_path__ + "static/media/website-widget.d49ade72.svg";